export const API_BASE = import.meta.env.VITE_API_BASE_URL || "https://botmaker-admin.workers.dev";
export const PLANS = [
  { id: "free", name: "FREE", price: 0, features: ["1 bot", "Free templates", "Community support"] },
  { id: "pro", name: "PRO", price: 99, features: ["5 bots", "All templates", "Priority support"] },
  { id: "vip", name: "VIP", price: 299, features: ["Unlimited bots", "VIP templates", "AI limits"] },
  { id: "lifetime", name: "LIFETIME", price: 999, features: ["Everything forever", "Unlimited bots", "Top priority"] }
];
export const THEMES = ["green", "blue", "red", "gold", "dark", "rainbow"];
